import { useEffect, useMemo, useState, useRef } from "react";
import useHttp from "./useHttp";
import { getEnvironmentApiUrl } from "../services/General";
import { PatientChatsMap } from "../context/ChatContext";

export const usePatientChats = (patientIds: number[], poll = true) => {
  const { sendRequest } = useHttp<PatientChatsMap>();
  const [patientChats, setPatientChats] = useState<PatientChatsMap>({});
  const intervalRef = useRef<number | null>(null);

  const patientIdsKey = useMemo(
    () => patientIds.sort().join(","), 
    [patientIds]
  );

  useEffect(() => {
    if (!patientIds.length) return;

    const fetchChats = () => {
      sendRequest(
        {
          url: getEnvironmentApiUrl() + `patient_chat/get_patient_chats`,
          method: "POST",
          body: patientIds,
        },
        (data) => {
          setPatientChats(prev => ({
            ...prev,
            ...data, // merge instead of overwrite
          }));
        },
        console.error
      );
    };

    fetchChats();

    if (poll) {
      intervalRef.current = window.setInterval(fetchChats, 10000);
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [patientIdsKey, sendRequest, poll]);

  return patientChats;
};